const defaultState = {
  list: [],
  item: null,
}

const teacher = (state = defaultState, action) => {
  switch (action.type) {
    case 'GET_TEACHERS':
      return {...state, list: action.data};
    case 'CREATE_TEACHER':
      return {...state, list: [...state.list, action.data]};
    case 'UPDATE_TEACHER':
      return {
        ...state, 
        list: state.list.map(item => {
          if(item.id == action.data.id){
            return {...item, ...action.data}
          } 
          return {...item};
        }) }
    default:
      return state
  }
}

export default teacher;


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/redux/reducers/teacher.js